<div class="webuniversum content-header content-header--large content-header--has-actions content-header--has-context">
    <div class="webuniversum content-header__wrapper">
      <picture class="webuniversum content-header__bg">
        <picture>
          <!--[if IE 9]><video style="display: none;"><![endif]-->
          <source src="assets\images\bos2.jpeg" media="(min-width: 1024px)" />
          <source src="assets\images\bos2.jpeg" media="(max-device-width: 767px)" />
          <source src="assets\images\bos2.jpeg" media="(max-width: 1023px)" />
          <!--[if IE 9]></video><![endif]-->
          <img src="assets\images\bos2.jpeg" alt="" title="" />
        </picture>
      </picture>
      <div class="layout layout--wide">
        <div class="webuniversum content-header__content">
            <h1 class="content-header__title"><span class="content-header__title__content">Natuur in je buurt</span></h1>
        </div>
      </div>
    </div>
  </div>
  